import {
  KeyboardSensor,
  MouseSensor,
  closestCenter,
  pointerWithin,
  useSensor,
  useSensors,
  type CollisionDetection,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

/**
 * Mouse drags plus the keyboard alternative: focus a handle, Space to pick up, arrows to move,
 * Space to drop. Pair with `sortableCollisionDetection`.
 */
export const useSortableSensors = () =>
  useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 6 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );

// Keyboard drags carry no pointer coordinates, so pointerWithin never finds a target for them.
export const sortableCollisionDetection: CollisionDetection = (args) =>
  args.pointerCoordinates ? pointerWithin(args) : closestCenter(args);

// Keeps the grabbing cursor over the whole list mid-drag; set `data-dragging="true"` on the host.
export const sortableDraggingSx = {
  '&[data-dragging="true"], &[data-dragging="true"] *': { cursor: 'grabbing !important' },
} as const;
